/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Dashboard_Detail_Source_StripeInputs */



/**
* | output |
* | --- |
* | "Stripe-aligned · excl. tax & discounts" |
*
* @param {Partner_Dashboard_Detail_Source_StripeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_detail_source_stripe = /** @type {((inputs?: Partner_Dashboard_Detail_Source_StripeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Detail_Source_StripeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stripe-abgeglichen · ohne Steuer & Rabatte")
	return /** @type {LocalizedString} */ ("Stripe-aligned · excl. tax & discounts")
});